
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16",
    "fill": "",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "g",
      "attrsMap": {
        "clip-path": "url(#clip0_2542_6211)"
      },
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "d": "M5.2207 0.570312H2.5957C1.45898 0.570312 0.533203 1.49609 0.533203 2.63281V5.25781C0.533203 6.39453 1.4584 7.32031 2.5957 7.32031H6.3457C6.59426 7.32003 6.83255 7.22117 7.00831 7.04542C7.18406 6.86966 7.28292 6.63137 7.2832 6.38281V2.63281C7.2832 1.49609 6.35801 0.570313 5.2207 0.570312ZM6.5332 6.38281C6.5332 6.40744 6.52835 6.43182 6.51893 6.45457C6.50951 6.47731 6.4957 6.49798 6.47829 6.51539C6.46087 6.53281 6.4402 6.54662 6.41746 6.55604C6.39471 6.56546 6.37033 6.57031 6.3457 6.57031H2.5957C2.24772 6.56994 1.9141 6.43154 1.66804 6.18548C1.42198 5.93942 1.28358 5.60579 1.2832 5.25781V2.63281C1.28358 2.28483 1.42198 1.95121 1.66804 1.70515C1.9141 1.45909 2.24772 1.32068 2.5957 1.32031H5.2207C5.56869 1.32068 5.90231 1.45909 6.14837 1.70515C6.39443 1.95121 6.53283 2.28483 6.5332 2.63281V6.38281ZM13.4707 0.570312H10.8457C9.70898 0.570312 8.7832 1.49609 8.7832 2.63281V6.38281C8.78348 6.63137 8.88234 6.86966 9.0581 7.04542C9.23385 7.22117 9.47215 7.32003 9.7207 7.32031H13.4707C14.6074 7.32031 15.5332 6.39453 15.5332 5.25781V2.63281C15.5332 1.49609 14.608 0.570313 13.4707 0.570312ZM14.7832 5.25781C14.7828 5.60579 14.6444 5.93942 14.3984 6.18548C14.1523 6.43154 13.8187 6.56994 13.4707 6.57031H9.7207C9.69608 6.57031 9.6717 6.56546 9.64895 6.55604C9.6262 6.54662 9.60553 6.53281 9.58812 6.51539C9.57071 6.49798 9.5569 6.47731 9.54748 6.45457C9.53805 6.43182 9.5332 6.40744 9.5332 6.38281V2.63281C9.53357 2.28483 9.67198 1.95121 9.91804 1.70515C10.1641 1.45909 10.4977 1.32068 10.8457 1.32031H13.4707C13.8187 1.32068 14.1523 1.45909 14.3984 1.70515C14.6444 1.95121 14.7828 2.28483 14.7832 2.63281V5.25781ZM6.3457 8.82031H2.5957C1.4584 8.82031 0.533203 9.74609 0.533203 10.8828V13.5078C0.533203 14.6445 1.4584 15.5703 2.5957 15.5703H5.2207C6.35742 15.5703 7.2832 14.6445 7.2832 13.5078V9.75781C7.28292 9.50926 7.18406 9.27096 7.00831 9.09521C6.83255 8.91945 6.59426 8.82059 6.3457 8.82031ZM6.5332 13.5078C6.53283 13.8558 6.39443 14.1894 6.14837 14.4355C5.90231 14.6815 5.56869 14.8199 5.2207 14.8203H2.5957C2.24772 14.8199 1.9141 14.6815 1.66804 14.4355C1.42198 14.1894 1.28358 13.8558 1.2832 13.5078V10.8828C1.28358 10.5348 1.42198 10.2012 1.66804 9.95515C1.9141 9.70909 2.24772 9.57068 2.5957 9.57031H6.3457C6.37033 9.57031 6.39471 9.57516 6.41746 9.58459C6.4402 9.59401 6.46087 9.60782 6.47829 9.62523C6.4957 9.64264 6.50951 9.66331 6.51893 9.68606C6.52835 9.70881 6.5332 9.73319 6.5332 9.75781V13.5078ZM13.4707 8.82031H9.7207C9.47215 8.82059 9.23385 8.91945 9.0581 9.09521C8.88234 9.27096 8.78348 9.50926 8.7832 9.75781V13.5078C8.7832 14.6445 9.70898 15.5703 10.8457 15.5703H13.4707C14.6074 15.5703 15.5332 14.6445 15.5332 13.5078V10.8828C15.5332 9.74609 14.608 8.82031 13.4707 8.82031ZM14.7832 13.5078C14.7828 13.8558 14.6444 14.1894 14.3984 14.4355C14.1523 14.6815 13.8187 14.8199 13.4707 14.8203H10.8457C10.4977 14.8199 10.1641 14.6815 9.91804 14.4355C9.67198 14.1894 9.53357 13.8558 9.5332 13.5078V9.75781C9.5332 9.70808 9.55296 9.66039 9.58812 9.62523C9.62328 9.59007 9.67098 9.57031 9.7207 9.57031H13.4707C13.8187 9.57068 14.1523 9.70909 14.3984 9.95515C14.6444 10.2012 14.7828 10.5348 14.7832 10.8828V13.5078Z",
            "fill": "",
            "stroke": "#224422",
            "stroke-width": "0.2"
          }
        }
      ]
    },
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip0_2542_6211"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "width": "16",
                "height": "16",
                "fill": ""
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  